import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { CoreModule } from '@app/core/core.module';
import { TranslateModule } from '@ngx-translate/core';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ChartModule, HIGHCHARTS_MODULES  } from 'angular-highcharts';
import * as more from 'highcharts/highcharts-more.src';
import * as exporting from 'highcharts/modules/exporting.src';
import * as fullScreen from 'highcharts/modules/full-screen.src';
import * as offlineexporting from 'highcharts/modules/offline-exporting.src'
import { AbstractStatsService } from '@app/Services/statistics/abstract.stats.service';
import { StatisticsRoutingModule } from './statistics-routing.module';
import { StatisticsComponent } from './statistics.component';
import { StatsService } from '@app/Services/statistics/stats.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { SharedModule } from '../shared/shared.module';


@NgModule({
  declarations: [
    StatisticsComponent
  ],
  imports: [
    CommonModule,
    StatisticsRoutingModule,
    CoreModule,
    TranslateModule,
    FormsModule,
    TableModule,
    RadioButtonModule,
    ButtonModule,
    ToastModule,
    NgbModule,
    SharedModule,
    ChartModule,
    MultiSelectModule
  ],
  providers: [
    { provide: AbstractStatsService, useClass: StatsService },
    { provide: HIGHCHARTS_MODULES, useFactory: () => [ more, exporting, offlineexporting, fullScreen ] }
  ]
})
export class StatisticsModule { }
